module.exports = __webpack_public_path__ + "static/media/img15.f0fad7bc.JPG";